<template>
    <component :is="isSingleQuote ? SingleQuote : MultiQuote" :quotes="quotes" />
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/main";
import SingleQuote from "@/views/YourQuotes/SingleQuote.vue";
import MultiQuote from "@/views/YourQuotes/MultiQuote.vue";
import { computed, onMounted } from "vue";
import { useProposalStore } from "@/stores/risk/risk";
import { APP_STEP } from "@/stores/types";

const mainStore = useMainStore();
const proposalStore = useProposalStore();
mainStore.setAppStep(APP_STEP.QUOTES);

const cachedQuotes = computed(() => proposalStore.cachedQuotes);
const displayCachedQuotes = computed(() => proposalStore.displayCachedQuotes);
const quotes = computed(() =>
    displayCachedQuotes.value
        ? cachedQuotes.value
        : proposalStore.validQuotes.length > 0
          ? proposalStore.validQuotes
          : proposalStore.proposal.quotes
);

const isSingleQuote = computed(() => quotes.value.length === 1);
</script>
